document.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector('.header');
	const footer = document.querySelector('.footer');
	const areaList = header.querySelector('.service-areas');
	const initArea = localStorage.getItem('area') || header.getAttribute('alternative');
	const headerMenuItems = Array.from(header.querySelectorAll(`.list-menu__item[action]`));
	const footerMenuItems = Array.from(footer.querySelectorAll('.list-menu__item[action]'));
	const menuItems = headerMenuItems.concat(footerMenuItems);
	const alternativeLinks = {
	};
	for (const menuItem of menuItems) {
		if (menuItem.getAttribute('alternative') === initArea) {
			menuItem.classList.remove('hidden');
		} else {
			menuItem.classList.add('hidden');
		}
	}
	const options = areaList.querySelectorAll('option');
	areaList.addEventListener('change', () => {
		const area = options[areaList.selectedIndex].value;
		localStorage.setItem('area', area);
		for (const menuItem of menuItems) {
			if (menuItem.getAttribute('alternative') === area) {
				menuItem.classList.remove('hidden');
			} else {
				menuItem.classList.add('hidden');
			}
		}
		updatePage(area);
	});
	const updateSwitch = (area) => {
		for (const [index, option] of options.entries()) {
			if (option.value === area) {
				areaList.selectedIndex = index;
				break;
			}
		}
	}
	const updatePage = (area) => {
		for (const key in alternativeLinks) {
			for (const link of alternativeLinks[key]) {
				if (!link.classList.contains('hidden') && link.getAttribute('alternative') === area) {
					let href = '';
					const i = location.href.indexOf('?');
					const withoutParam = i === -1 ? location.href : location.href.substring(0, i);
					let j = location.pathname.lastIndexOf('/');
					if (j !== -1) {
						href = location.pathname.substring(j);
					}
					if (link.tagName.toLowerCase() === 'a') {
						if (link.href !== withoutParam) {
							if (clickValidationLink(href, link)) {
								return;
							}
						}
					} else {
						const subLinkList = Array.from(link.nextElementSibling.querySelectorAll('a'));
						for (const subLink of subLinkList) {
							if (subLink.href !== withoutParam) {
								if (clickValidationLink(href, subLink)) {
									return;
								}
							}
						}
					}
				}
			}
		}
	}
	const updateInitSwitch = (area) => {
		if(location.pathname !== '/') {
			const currentLink = document.querySelector(`a[href="${location.pathname}"]`);
			if(!currentLink) {
				return;
			}
			let targetArea = '';
			if(currentLink.getAttribute('action') !== null) {
				targetArea = currentLink.getAttribute('alternative');
			} else {
				let link = currentLink;
				while(1) {
					const summaryTag = link.closest('ul')?.closest('details')?.querySelector('summary');
					if(summaryTag) {
						if(summaryTag.getAttribute('action') !== null) {
							targetArea = summaryTag.getAttribute('alternative');
							break;
						}
						link = summaryTag;
					} else {
						break;
					}
				}
			}
			if(targetArea !== '') {
				updateSwitch(targetArea);
				areaList.dispatchEvent(new Event('change'));
			}
		}
	}
	const getAlternativeLinks = () => {
		for (const menuItem of menuItems) {
			const action = menuItem.getAttribute('action');
			if (action) {
				let isValide = false;
				if (menuItem.querySelector('svg')) {
					isValide = true;
				} else {
					const href = menuItem.getAttribute('href');
					if (href !== '' && href !== '#') {
						isValide = true;
					}
				}
				if (isValide) {
					if (!alternativeLinks[action]) {
						alternativeLinks[action] = [];
					}
					alternativeLinks[action].push(menuItem);
				}
			}
		}
	}
	const clickValidationLink = (href, a) => {
		const i = a.href.lastIndexOf('/');
		if (i !== -1) {
			const href1 = a.href.substring(i);
			if (href === href1) {
				a.click();
				return true;
			}
		}
		return false;
	}
	getAlternativeLinks();
	updateSwitch();
	updateInitSwitch();
});